export default __webpack_public_path__ + "static/media/sunrise.e020b8b1.png";